const APPROVABLE_STATUSES = [
  'Request Submitted',
  'Manager Approved',
  'Payroll Manager Approved',
];

const HR_REQUEST_DELETE_ALLOWED_EMAIL = 'm.ghous@seazengroup.com';

/**
 * Whether the signed-in user can delete HR requests from the portal.
 */
export function canDeleteHrRequest(userProfile) {
  return (userProfile?.email || '').trim().toLowerCase()
    === HR_REQUEST_DELETE_ALLOWED_EMAIL.toLowerCase();
}

/**
 * Whether the signed-in user can delete employees from the portal.
 */
export function canDeleteEmployee(userProfile) {
  return canDeleteHrRequest(userProfile);
}

/**
 * Whether the signed-in user can approve/reject this HR request in the portal.
 */
export function canApproveHrRequest(leave, userProfile, currentView) {
  if (!leave || !userProfile) return false;

  const status = leave.status === 'Pending' ? 'Request Submitted' : leave.status;
  if (!APPROVABLE_STATUSES.includes(status)) return false;

  const role = userProfile.role;

  if (role === 'manager') {
    if (status !== 'Request Submitted') return false;
    return currentView === 'my_team_requests';
  }

  if (role === 'admin' || role === 'super') {
    return true;
  }

  return false;
}

/**
 * Whether the HR request detail can be printed (final HR approval only).
 */
export function canPrintHrRequest(leave) {
  return leave?.status === 'HR Manager Approved';
}
